// extracted by mini-css-extract-plugin
module.exports = {"container":"AlsoAvailableOnSectionHeader_container__m_a_r"};